import { faArrowRight, faCircleXmark } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Card } from "antd";
import { useLocation, useNavigate } from "react-router-dom";

export default function DocumentAlarm({ data }) {
    const location = useLocation();
    const navigate = useNavigate();
    return (
        <Card className="shadow-sm rounded-xl h-full">
            <div className="flex justify-between items-baseline mb-2">
                <span className="text-[18px] font-semibold" title="Mandatory documents missing 7 days prior to ETA">
                    Document Alarm
                </span>
                <span className="text-[14px] text-primary hover:cursor-pointer" onClick={() => navigate("/shipment-gateway")}>
                    See more <FontAwesomeIcon icon={faArrowRight} />
                </span>
            </div>
            <div className="space-y-1">
                {data?.map((item) => (
                    <div key={item?.containerNum} className="shadow-md rounded-xl px-2 py-1">
                        <div className="flex justify-between items-center">
                            <div className="min-w-0 flex-1">
                                <Button
                                    className="w-32 overflow-hidden whitespace-nowrap font-bold text-sm"
                                    type="primary"
                                    onClick={() => navigate("/shipment-gateway/shipment-details", {
                                        state: {
                                            pathname: location.pathname,
                                            containerID: item?.containerID,
                                            selectedContainerNum: item?.containerNum,
                                        }
                                    })}
                                >
                                    {item?.containerNum}
                                </Button>
                                <div className="text-[14px] text-gray-500 truncate mt-0.5 flex items-center gap-1">
                                    <FontAwesomeIcon icon={faCircleXmark} className="text-danger text-base" />
                                    <span>{item?.missingDocTypes?.join(", ")}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </Card>
    );
}